<template>
    <div class="user" v-if="hasRoleEnfermera">
        <div class="photo">
            <md-icon style="color: white !important; margin-left: 5px"
                >home</md-icon
            >
        </div>
        <div class="user-info">
            <a
                data-toggle="collapse"
                :aria-expanded="!isClosed"
                @click.stop="toggleMenu"
                @click.capture="clicked"
            >
                <span>
                    {{ $t("centros") }}
                    <b class="caret"></b>
                </span>
            </a>
            <collapse-transition>
                <div v-show="!isClosed">
                    <ul class="nav">
                        <slot>
                            <li
                                v-bind:class="{
                                    active: centro.id == currentId,
                                    '': centro.id != currentId,
                                }"
                                v-for="centro in centros"
                                v-bind:key="centro.id"
                            >
                                <a v-on:click="changeCentro(centro)">
                                    <span class="sidebar-normal">{{
                                        centro.nombre
                                    }}</span>
                                </a>
                            </li>
                        </slot>
                    </ul>
                </div>
            </collapse-transition>
        </div>
    </div>
</template>
<script>
import { EventBus } from "../../../../helpers/EventBus";
let user = JSON.parse(localStorage.getItem("instantcare_user"));
export default {
    data() {
        let user = JSON.parse(localStorage.getItem("instantcare_user"));
        return {
            isClosed: true,
            centros: user.centros,
            hasRoleEnfermera: user.roles.includes("ROLE_ENFERMERA"),
            currentId: null,
        };
    },
    methods: {
        changeCentro(centro) {
            this.currentId = centro.id;
            sessionStorage.setItem("idCentro", JSON.stringify(centro));
            EventBus.$emit("cambio-centro");
        },
        clicked: function (e) {
            e.preventDefault();
        },
        toggleMenu: function () {
            this.isClosed = !this.isClosed;
        },
    },
};
</script>
<style>
.collapsed {
    transition: opacity 1s;
}

.text-danger {
    color: red !important;
}
</style>
